<template>
    <div class="w-100 rounded mb-3" style="overflow: hidden; position: relative;">
        <div class="position-absolute location-list w-50" style="z-index: 2">
            <div v-for="(marker, index) in markers" v-bind:key="index" class="card mb-2">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div>
                            <img src="~@/assets/checkout/postnl-logo.svg" alt="">
                        </div>
                        <div class="d-flex w-100 mt-2 ml-2 align-items-end">
                            <h6 class="font-weight-bold">{{ marker.name }}</h6>
                            <h6 class="font-weight-light text-theme-red ml-auto marker-distance">{{ marker.distance }}</h6>
                        </div>
                    </div>
                    <p class="card-text mt-2 marker-address">{{ marker.location }}</p>
                    <div class="divider"></div>
                    <p class="card-text mt-3 marker-opening-hours">Morgen Geopend: {{ marker.opening_hours }}</p>
                    <p class="card-text marker-view-opening">View Opening Time<font-awesome-icon class="ml-1" icon="chevron-right"/></p>
                    <div class="mt-2">
                        <button 
                            type="button"
                            @click="changeMarker(marker)"
                            :class="selectedMarker === marker.id ? 'selected-button' : 'select-button'" 
                            class="btn btn-primary w-100"
                            >
                            <span>
                                <font-awesome-icon class="mr-1" icon="check" v-if="selectedMarker === marker.id"/>
                                {{ selectedMarker === marker.id ? "Selected" : "Select"}}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="map" class="w-100"></div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
    name: 'CollectionPoint',
    data() {
        return {
            selectedMarker: null,
            markers: [
                {
                    id: 1,
                    coordinates: [4.899938, 52.370662],
                    location: 'Nieuwe Hoogstraat 22-H, 1011 HG Amsterdam, Netherlands',
                    opening_hours: "10:00 - 19:00",
                    name: "Pickup Point 1",
                    distance: "98m"
                },
                {
                    id: 2,
                    coordinates: [4.893958, 52.370667],
                    location: 'Nieuwe Hoogstraat 22-H, 1011 HG Amsterdam, Netherlands',
                    opening_hours: "10:00 - 19:00",
                    name: "Pickup Point 2",
                    distance: "151m"
                },
                {
                    id: 3,
                    coordinates: [4.892938, 52.370662],
                    location: 'Nieuwe Hoogstraat 22-H, 1011 HG Amsterdam, Netherlands',
                    opening_hours: "10:00 - 19:00",
                    name: "Pickup Point 3",
                    distance: "32m"
                },
                {
                    id: 4,
                    coordinates: [4.899938, 52.374662],
                    location: 'Nieuwe Hoogstraat 22-H, 1011 HG Amsterdam, Netherlands',
                    opening_hours: "10:00 - 19:00",
                    name: "Pickup Point 4",
                    distance: "188m"
                },
                {
                    id: 5,
                    coordinates: [4.891938, 52.370662],
                    location: 'Nieuwe Hoogstraat 22-H, 1011 HG Amsterdam, Netherlands',
                    opening_hours: "10:00 - 19:00",
                    name: "Pickup Point 5",
                    distance: "12m"
                },
            ],
            mapBoxMap: null,
            savedMarkers: [],
        }
    },
    watch: {
        selectedMarker(markerId) {
            const markers = this.markers
            
            this.savedMarkers.forEach(marker => {
                marker.remove();
            });

            markers.forEach(marker => {
                const pinColor = marker.id === markerId ? '#FF6E88' : '#443853'
                const toPush = new mapboxgl.Marker({ color: pinColor })
                    .setLngLat(marker.coordinates) // set the coordinates of the marker
                    .addTo(this.mapBoxMap); // add the marker to the map

                this.savedMarkers.push(toPush);
            });
        }
    },
    methods: {
        changeMarker(marker) {
            if(marker.id === this.selectedMarker) {
                this.selectedMarker = null
            } else {
                this.selectedMarker = marker.id
            }
        }
    },
    mounted() {
        mapboxgl.accessToken = 'pk.eyJ1Ijoic2VuZGNsb3VkZG90c2MiLCJhIjoiY2l1bzA1dG9sMDAxMjJ5bXdlYm9oMTJ3OCJ9.IOkuwHjGsHQDbrf7rMr5Zw';
        this.mapBoxMap = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/light-v11',
            center: [4.832738, 52.329662], // San Francisco, CA
            zoom: 12,
            interactive: false
        });

        const markers = this.markers
  
        markers.forEach(marker => {
            const toPush = new mapboxgl.Marker({ color: '#443853' })
                .setLngLat(marker.coordinates) // set the coordinates of the marker
                .addTo(this.mapBoxMap); // add the marker to the map

            this.savedMarkers.push(toPush);
        });
    }
}
</script>

<style>
#map {
    height: 300px;
    position: relative;
    z-index: 1;
}

.location-list {
    left: 1rem;
    top: 0;
    overflow-y: scroll;
    max-height: 300px;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;
}

.location-list::-webkit-scrollbar {
    display: none;
}

.text-theme-red {
    color: #FF6E88
}

.marker-distance {
    font-size: small;
}

.marker-address {
    font-size: small;
}

.marker-opening-hours {
    margin-bottom: 0 !important;
    font-size: small;
}

.marker-view-opening {
    margin-bottom: 0 !important;
    font-size: small;
    font-weight: 1000;
    cursor: pointer;
}

.divider {
    border-top: 1px solid #D5DCE3;
}

.select-button {
    background-color: #ffffff;
    font-weight: bold;
    font-size: 0.7rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    border-radius: 15px;
    color: #FF6E88;
    border: 1px solid #FF6E88;
}

.select-button:hover {
    background-color: #FF6E88;
    font-weight: bold;
    font-size: 0.7rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    border-radius: 15px;
    border: 1px solid #FF6E88;
    color: #ffffff;
}

.selected-button {
    background-color: #FF6E88;
    font-weight: bold;
    font-size: 0.7rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    border-radius: 15px;
    border: 1px solid #FF6E88;
    color: #ffffff;
}
</style>